import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {
  AUDIENCE_RECALCULATION_STATUS_QUERY_KEY,
  AUDIENCES_QUERY_KEY,
  CAMPAIGNS_QUERY_KEY,
  SEGMENTS_QUERY_KEY,
} from "../queryKeys";
import {ReachSegment, SegmentsBatchPayload} from "./types";

const saveSegmentsBatch = async (payload: SegmentsBatchPayload): Promise<ReachSegment[]> => {
  const response = await axiosReachInstance.post<ReachSegment[], AxiosResponse<ReachSegment[]>, SegmentsBatchPayload>(
    "/segments/batch",
    payload
  );
  return response.data;
};

export const useSaveSegmentsBatch = (
  options?: BaseMutationOptions<ReachSegment[], SegmentsBatchPayload>
): BaseUseMutationResult<ReachSegment[], SegmentsBatchPayload> => {
  return useBaseMutation<ReachSegment[], SegmentsBatchPayload>(saveSegmentsBatch, {
    ...options,
    prefixKeysToReset: () => [
      [SEGMENTS_QUERY_KEY],
      [AUDIENCES_QUERY_KEY],
      [AUDIENCE_RECALCULATION_STATUS_QUERY_KEY],
      [CAMPAIGNS_QUERY_KEY],
    ],
  });
};
